import AsyncStorage from '@react-native-async-storage/async-storage';
import refreshToken from '../components/RefreshToken';
import { getAuthToken } from '../components/AuthSession';

const call = async (method: string, endpoint: string, body?: object) => {
  try {
    const clientName = await AsyncStorage.getItem('clientName');
    const apiDomain = await AsyncStorage.getItem('apiDomain') ?? 'api-v2.hereworks.tech';
    const jwtToken = await getAuthToken();

    // eslint-disable-next-line no-undef
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('clientid', clientName ?? 'hereworks');
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('jwt', jwtToken ?? '');

    const params: { method: string, headers: Headers, body?: string } = {
      method, headers: requestHeaders,
    };
    if (body) params.body = JSON.stringify(body);

    return fetch(`https://${apiDomain}/${endpoint}`, params)
      .then((res) => {
        if (res && jwtToken) {
          if (res.status === 401) refreshToken();
          return res.json().then((json) => json);
        }
        return null;
      });
  } catch (error) {
    return null;
  }
};

const get = (endpoint: string) => call('GET', endpoint);

const put = (endpoint: string, body: object) => call('PUT', endpoint, body);

const post = (endpoint: string, body: object) => call('POST', endpoint, body);

const patch = (endpoint: string, body: object) => call('PATCH', endpoint, body);

const deleteRequest = (endpoint: string, body?: object) => call('DELETE', endpoint, body);

export {
  get, put, post, deleteRequest, patch,
};
